import { ComponentProps } from 'react'
import { Button } from '@alto-avios/alto-ui'
import { useAlertContext } from './AlertProvider'
import styles from './Alert.module.scss'

export const AlertButton = (props: ComponentProps<typeof Button>) => {
  const { status } = useAlertContext()

  return (
    <div className={styles.button} data-status={status}>
      <Button emphasis="secondary" size="md" {...props} />
    </div>
  )
}
